import { render, staticRenderFns } from "./MenuBetaBadge.vue?vue&type=template&id=3cb8ce04&scoped=true"
import script from "./MenuBetaBadge.vue?vue&type=script&lang=js"
export * from "./MenuBetaBadge.vue?vue&type=script&lang=js"
import style0 from "./MenuBetaBadge.vue?vue&type=style&index=0&id=3cb8ce04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb8ce04",
  null
  
)

export default component.exports